import { ApiRequest } from "GlobalFunctions";
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { PiXCircle } from "react-icons/pi";
import { Button } from "@mui/material";
import { useSnackbar } from 'notistack';

export default function EmailChangeVerification(params: any) {
      const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const { setLoading } = params;

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState('');

    useEffect(() => {
        const code = searchParams.get('code');
        const type = searchParams.get('type');

        if (!code || !type) {
            setMessage('Invalid verification link.');
            setLoading(false);
            return;
        }

        verifyEmailChange(code, type);
    }, [searchParams]);

    const verifyEmailChange = async (code: string, type: string) => {
        setLoading(true);

        await ApiRequest({
            url: `/stores/verifyEmailChangeCode?code=${code}&type=${type}`,
            method: 'GET',
            setResponse: (response: any) => {
                if (response.status === 'success') {
                    if (response.message === 'both_verified') { 
                        setMessage('success');
                        enqueueSnackbar('Email Verified!', { variant: 'success' });
                    } else if (response.message === 'one_verified') {
                        setMessage(response.data.message);
                        enqueueSnackbar(`${type.charAt(0).toUpperCase() + type.slice(1)} Email Verified!`, { variant: 'success' });
                    }
                } else {
                    if (response.message === 'no_pending_request' || response.message === 'expired') {
                        setMessage('error');
                    } else {
                        setMessage(response.message || 'Failed to verify email change.');
                    }

                    enqueueSnackbar('The Link Has Expired', { variant: 'error' });
                }
                setLoading(false);
            }
        });
    };

    // Determine message type and styling
    const isSuccess = message === 'success';
    const isError = message === 'error';
    
    let containerClass = 'change-email-toast-container';
    
    if (isSuccess) {
        containerClass = 'reset-toast-container';
    } else if (isError) {
        containerClass = 'error-message-toast';
    }

    // Render content based on message type
    const renderContent = () => {
        if (isSuccess) {
            return <div>Your email has been successfully updated.</div>;
        } else if (isError) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <PiXCircle size={24} color="#BD2427" />
                    <span>You have no pending requests. Previous requests may have been canceled or expired.</span>
                </div>
            );
        } else {
            return <div dangerouslySetInnerHTML={{ __html: message }} />;
        }
    };

    return (
        <div className='ModuleContainer alt_container'>
            <div className="ModuleHeader">
                <h1>Account</h1>
                <div className="ModuleActions">
                    
                </div>
            </div>
            <div className='ModuleContent'>
                <div className="account_section">
                    <div className="section_header">
                        <h2>Edit Email</h2>
                        <div className="section_actions">
                            <Button
                                variant="contained"
                                onClick={() => navigate('/account')}
                                className="alt_btn"
                            >
                                Return To Account
                            </Button>
                        </div>
                    </div>

                    <div className={containerClass}>
                        {renderContent()}
                    </div>
                </div>
            </div>
        </div>
    );
}
